export default "__VITE_ASSET__C76Tnsr4__"